export default function COUNTA() {
  return <div>Excel_COUNTA</div>;
}
